export const colors = {
    lightgreen: '#93B1A6',
    green: '#5C8374',
    darkgreen: '#183D3D',
    black:'#040D12',
}